<template>
    <div>
        <p class="hidden tablet:block m-0 text-[16px] font-lato font-bold text-[#092E87]">Add Notes</p>
        <div class="rounded-[10px] border-1 border-[#CCCCCC]">
            <div ref="notesContainer" class="flex flex-col gap-2 p-2 min-h-[350px] max-h-[350px] overflow-x-hidden overflow-y-auto [scrollbar-width:thin] 
                [scrollbar-color:#ff5b00_#f3f3f3]
                [&&::-webkit-scrollbar]:w-[6px]
                [&&::-webkit-scrollbar-track]:bg-[#f3f3f3]
                [&&::-webkit-scrollbar-track]:!rounded-full
                [&&::-webkit-scrollbar-thumb]:bg-[#ff5b00]
                [&&::-webkit-scrollbar-thumb]:!rounded-full
                [&&::-webkit-scrollbar-thumb:hover]:bg-[#e94d00]
                [&&::-webkit-scrollbar-button]:!hidden">
                <div v-for="(item, index) in jobNotes" :key="index">
                    <div class="relative p-2.5 !pr-[30px] rounded-[10px] bg-opacity-50 bg-[#EFEFEF]">
                        <p class="m-0 text-[14px] laptop:text-[16px] text-[#333333] break-all whitespace-pre-line">{{
                            item.notes }}</p>
                    </div>
                    <div class="text-[14px] text-[#999999]">
                        {{ $helper.formatDateTimestamp(item.created_at_timestamp, 'hh:mm A - MM/DD/YYYY') }}</div>
                </div>
                <div v-if="jobNotes?.length < 1" class="text-center mt-3 text-[#999999]">
                    No notes available
                </div>
            </div>
            <div
                class="relative m-[5px] rounded-[10px] overflow-hidden shadow-[0px_0px_20px_0px_#00000026] flex items-end pr-[50px]">

                <textarea ref="notesArea" v-model="notes" @input="autoResize" rows="1" class="p-[8px] w-full resize-none outline-none overflow-y-auto !pt-[14px]
                    min-h-[48px] max-h-[72px] hide-scrollbar leading-[20px]" placeholder="Enter notes here..."></textarea>
            
                <button :disabled="txtDisable" @click="addNotesBtn" class="absolute right-1 bottom-1 h-[40px] w-[50px] flex items-center justify-center rounded-[10px]
           bg-[#092E87] text-white disabled:bg-[#EFEFEF] disabled:text-[#999999]">
                    <img src="../../assets/images/sendIcon.png"
                        class="min-w-[24px] min-h-[24px] max-w-[24px] max-h-[24px]" />
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import moment from "moment";
import { useToast } from "vue-toastification";
const toast = useToast();

export default {
    components: {},

    data() {
        return {
            modal: null,
            selectedNotes: null,
            notes: "",
            jobNotes: [],
            txtDisable: true,
        };
    },
    computed: {
        ...mapGetters(["apptDetail", "notesData", "notesDataResponse"]),
    },

    watch: {
        notesData: function () {
            this.selectedNotes = null;
            this.notes = "";
            this.getNotesData()
        },

        notesDataResponse: function () {
            this.selectedNotes = null;
            this.notes = "";
            this.jobNotes = this.notesDataResponse ?? [];
            this.scrollToBottom()

        },

        notes: function () {
            if (!this.isEmpty(this.notes)) {
                this.txtDisable = false;
            } else {
                this.txtDisable = true;
            }
        },
    },

    mounted() {
        this.getNotesData()
    },

    methods: {
        ...mapActions(["addManualQuoteNote", "getManualQuotesNotes"]),
        autoResize() {
            const textarea = this.$refs.notesArea;
            textarea.style.height = "auto";
            textarea.style.height = Math.min(textarea.scrollHeight, 72) + "px";
            // 72px = approx 3 lines
        },
        resetTextareaHeight() {
            this.$nextTick(() => {
                const textarea = this.$refs.notesArea;
                if (textarea) {
                    textarea.style.height = "40px"; // 1 line height reset
                }
            });
        },
        getNotesData() {
            console.log(this.apptDetail.id);

            this.getManualQuotesNotes({
                id: this.apptDetail.id,
            });
        },

        addNotesBtn() {
            if (this.isValid()) {
                this.addManualQuoteNote({
                    id: this.apptDetail.id,
                    internal_notes: this.notes,
                });
            }
            this.notes = "";
            this.resetTextareaHeight();
        },
        isValid() {
            let res = true;
            if (this.isEmpty(this.notes)) {
                toast.error("Please enter note");
                res = false;
            }
            return res;
        },
        isEmpty(value) {
            return (
                value == null ||
                value.trim().length === 0 ||
                (value.constructor === Object && Object.keys(value).length === 0)
            );
        },

        scrollToBottom() {
            this.$nextTick(() => {
                const el = this.$refs.notesContainer;
                if (el) {
                    el.scrollTop = el.scrollHeight;
                }
            });
        }
    },
};
</script>
